<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {computed} from "vue";
import {useStore} from "vuex";

const store = useStore();

const competitor = computed(() => store.getters['competitionV2/competitor']);

</script>

<template>
  <DefaultButton
    variant="primary-inverted"
    as="a"
    target="_blank"
    class="py-2 px-4"
    :href="`/competition/export/backlinks/${competitor.id}`"
  >
    <span class="tw-font-semibold tw-antialiased">Export</span>
    <svg-vue
      icon="icons/download"
      class="tw-w-5 tw-h-5 tw-ml-2"
    />
  </DefaultButton>
</template>
